import React from "react";
import {
    Button,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";

interface OwnProps {
    onSave: () => void;
    isSaving: boolean;
};


const SaveButton = ({isSaving, onSave}: Pick<OwnProps, 'isSaving' | 'onSave'>) => {
    return <Button
    colorScheme="green"
    variant="outline"
    leftIcon={<FontAwesomeIcon icon={faSave} />}
    isLoading={isSaving}
    onClick={onSave}
>
    Guardar
</Button>;
}

export default SaveButton;
